import store from "store/store";


export const budgetBuilderSelectors = {
	budgetBuilderFormContent: state => state?.budgetBuilder?.content?.currentVersion
		? budgetBuilderSelectors.payload(state)?.budgetBuilderContent
		: budgetBuilderSelectors.payload(state)?.root?.budgetBuilderContent,
	budgetPeriods: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.budgetPeriods,
	budgetType: (state = store.getState()) => budgetBuilderSelectors.content(state)?.budgetType,
	caseInstanceId: (state = store.getState()) => budgetBuilderSelectors.payload(state)?.caseInstanceId,
	cachedPeopleById: state => budgetBuilderSelectors.content(state)?.cachedPeopleById,
	content: state => state?.budgetBuilder?.content,
	currentPeriod: state => budgetBuilderSelectors.content(state)?.currentPeriod,
	currentPeriodRate: state => budgetBuilderSelectors.currentPeriod(state)?.rateForPeriod || 0,
	currentPeriodData: forCostShare => {
		if (forCostShare) {
			return state => budgetBuilderSelectors.currentPeriod(state)?.costShare;
		} else {
			return state => budgetBuilderSelectors.currentPeriod(state)?.sponsorCosts;
		}
	},
	currentPeriodHasFringeRate: state => budgetBuilderSelectors.currentPeriod(state)?.hasFringeRate,
	currentPeriodHasSalaryRate: state => budgetBuilderSelectors.currentPeriod(state)?.hasSalaryRate,
	currentPeriodNumber: state => budgetBuilderSelectors.currentPeriod(state)?.periodNumber,
	currentVersion: state => budgetBuilderSelectors.content(state)?.currentVersion,
	displayCents: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.displayCents,
	externalCostShare: state => budgetBuilderSelectors.content(state)?.lineItems.externalCostShare,
	externalCostShareByPeriod: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.externalCostShareByPeriod,
	externalCostShareForPeriod: (state, periodNumber) =>
    budgetBuilderSelectors.externalCostShareByPeriod(state)?.[periodNumber],
	hasFringeRate: forCostShare => state => budgetBuilderSelectors.currentPeriodData(forCostShare)(state)?.hasFringeRate,
	hasSalaryRate: forCostShare => state => budgetBuilderSelectors.currentPeriodData(forCostShare)(state)?.hasSalaryRate,
	isFetching: state => budgetBuilderSelectors.content(state)?.isFetching,
	internalCostShare: state => budgetBuilderSelectors.content(state)?.lineItems.internalCostShare,
	internalCostShareByPeriod: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.internalCostShareByPeriod,
	internalCostShareForPeriod: (state, periodNumber) =>
    budgetBuilderSelectors.internalCostShareByPeriod(state)?.[periodNumber],
	rateForPeriod: (state, periodNumber) => budgetBuilderSelectors.periodRows(state)
		?.find(period => period.periodNumber === periodNumber)?.rateForPeriod,
	researchTeamMembers: (state = store.getState()) => budgetBuilderSelectors.content(state)?.researchTeam?.members,
	payload: state => budgetBuilderSelectors.content(state)?.payload,
	periodRows: state => budgetBuilderSelectors.budgetPeriods(state)?.periodRows || [],
	researchTeamByPeriod: state =>
    budgetBuilderSelectors.budgetBuilderFormContent(state)?.researchTeamByPeriod || [],
	researchTeamForPeriod: (state, periodNumber) =>
    budgetBuilderSelectors.budgetBuilderFormContent(state)?.researchTeamByPeriod?.[periodNumber],
	researchTeamForCurrentPeriod: state => {
		const currentPeriodNumber = budgetBuilderSelectors.currentPeriodNumber(state);

		return budgetBuilderSelectors.researchTeamForPeriod(state, currentPeriodNumber);
	},
	rollbackToVersionTaskId: state => budgetBuilderSelectors.payload(state)
		?.root?.budgetBuilderContent?.rollbackToVersionTaskId,
	sponsoredCosts: state => budgetBuilderSelectors.content(state)?.lineItems.sponsoredCosts,
	sponsoredCostsByPeriod: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.sponsoredCostsByPeriod,
	sponsoredCostsForPeriod: (state, periodNumber) =>
    budgetBuilderSelectors.sponsoredCostsByPeriod(state)?.[periodNumber],
	startNewVersionTaskId: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.startNewVersionTaskId,
	savedUnnamedMembers: state => budgetBuilderSelectors.budgetBuilderFormContent(state)?.researchTeamUnnamedMembers,
	unnamedMembers: (state = store.getState()) => state?.budgetBuilder?.content?.researchTeam?.unnamed,
	versions: state => budgetBuilderSelectors.payload(state)?.root?.budgetBuilderContent?.versions,
};
